import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css/bundle";
import { Instagram } from "@/types/app";
import { getImageUrl } from "@/utils/global";
import { Instagram as InstagramIcon } from "lucide-react";

const Ig = ({ data }: { data: Instagram[] }) => {
    return (
        <>
            <div className="instagram-block md:pt-20 pt-10 mb-10">
                <div className="container">
                    <div className="flex flex-col items-center text-center mb-8">
                        <div className="flex items-center gap-3 mb-4">
                            <InstagramIcon className="w-6 h-6 md:w-8 md:h-8 text-[#790546]" />
                            <h2 className="text-xl md:text-2xl font-bold text-gray-900 tracking-tight text-balance">
                                Patty Cariño Instagram
                            </h2>
                        </div>
                        <p className="text-gray-600 max-w-2xl text-sm md:text-base leading-relaxed px-6 text-balance">
                            #tortasPattycarino
                        </p>
                        <div className="w-16 h-0.5 bg-[#790546] rounded-full mt-5 mb-0"></div>
                    </div>
                    <div className="list-instagram md:mt-10 mt-6">
                        <Swiper
                            spaceBetween={12}
                            slidesPerView={2}
                            loop={true}
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 4000,
                            }}
                            breakpoints={{
                                500: {
                                    slidesPerView: 2,
                                    spaceBetween: 16,
                                },
                                680: {
                                    slidesPerView: 3,
                                    spaceBetween: 16,
                                },
                                992: {
                                    slidesPerView: 4,
                                    spaceBetween: 16,
                                },
                                1200: {
                                    slidesPerView: 5,
                                    spaceBetween: 16,
                                },
                            }}
                        >
                            {data?.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        className="item relative block rounded-[32px] overflow-hidden"
                                    >
                                        <img
                                            src={getImageUrl(item.img)}
                                            width={300}
                                            height={300}
                                            alt="1"
                                            className="h-full w-full duration-500 relative"
                                        />
                                        <div className="icon w-12 h-12 bg-white hover:bg-black duration-500 flex items-center justify-center rounded-2xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]">
                                            <div className="icon-instagram text-2xl text-black"></div>
                                        </div>
                                    </a>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Ig;
